import * as t from 'io-ts';

import {makeApiType, RCardIdRef, RCardNoteIdRef, RLazyTeammateIdRef} from './apiTypes';

/*
 * Runtime type.
 */

const RCardNoteDirty = t.readonly(
  t.type({
    id: t.Integer,
    url: t.string,
    cardId: RCardIdRef,
    authorId: RLazyTeammateIdRef,
    body: t.string,
    text: t.string,
    namespace: t.string,
    createdAt: t.Integer,
    updatedAt: t.Integer,
  }),
  'cardNote',
);

/*
 * Type.
 */

export interface CardNoteModel extends t.TypeOf<typeof RCardNoteDirty> {}
export const RCardNote = t.clean<CardNoteModel>(RCardNoteDirty as any);
export const RCardNotes = t.readonlyArray(RCardNote);
RCardNoteIdRef.setTargetType(RCardNote);

/*
 * IO methods.
 */

export function parseCardNote(src: any): CardNoteModel {
  return {
    id: src.id,
    url: src.url,
    cardId: src.card_id,
    authorId: src.author_id,
    body: src.body,
    text: src.text,
    namespace: src.namespace,
    createdAt: src.created_at || src.date,
    updatedAt: src.updated_at || 0,
  };
}

export function parseCardNotes(src: any) {
  return src.card_notes && src.card_notes.map(parseCardNote);
}

/*
 * API type.
 */

export const ApiCardNote = makeApiType('cardNote', RCardNote, parseCardNote);
export const ApiCardNotes = makeApiType('cardNotes', RCardNotes, parseCardNotes);
